import type { SellerConnection } from '../../api/amazonconnect';
import { fetchOrdersMetricsSeries } from '../ordersTruth';
import { buildSalesPulseModel } from './buildHourly';
import type { SalesPulseModel } from './types';

function isoShift(days: number, now = new Date()): string {
  const d = new Date(now);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + days);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export async function loadSalesPulse(opts: {
  connection: SellerConnection | null;
}): Promise<SalesPulseModel> {
  const conn = opts.connection;
  const connectionId = conn?.id ?? null;
  const marketplaceId =
    conn?.marketplace_ids?.[0] ?? conn?.marketplaces?.[0]?.marketplace_id;
  const sellerRef = conn?.seller_ref ?? undefined;

  if (!connectionId) {
    return buildSalesPulseModel({
      connectionId: null,
      orders: [],
      truncated: false,
      error: null,
      sellerRef,
      marketplaceId,
    });
  }

  try {
    const series = await fetchOrdersMetricsSeries(connectionId, {
      from: isoShift(-30),
      to: isoShift(0),
      grain: 'hour',
    });
    return buildSalesPulseModel({
      connectionId,
      marketplaceId,
      sellerRef,
      orders: [],
      series: series.buckets ?? [],
      truncated: false,
      error: null,
      source: series.source,
    });
  } catch (e) {
    return buildSalesPulseModel({
      connectionId,
      marketplaceId,
      sellerRef,
      orders: [],
      truncated: false,
      error: e instanceof Error ? e.message : 'Failed to load 24h sales pulse',
    });
  }
}
